import PersonIcon from '@material-ui/icons/Person';

import UserCreate from './UserCreate';
import UserList from './UserList';
import UserShow from './UserShow';
import UserEdit from './UserEdit';

const users = {
    icon: PersonIcon,
    list: UserList,
    create: UserCreate,
    edit: UserEdit,
    show: UserShow,
};

export default users;